<template>
  <div class="MyCascader">
    <el-dialog
      title="选择商品分类"
      maxHeight="null"
      :visible.sync="dialogTableVisible"
    >
      <el-cascader-panel
        ref="cascader"
        :options="options"
        @getCheckedNodes="getCascaderObj"
        @expand-change="handleItemChange($event)"
        @change="selectApi($event)"
        v-model="value"
        :props="props"
      />
      <div slot="footer" class="dialog-footer">
        <el-button
          size="mini"
          type="default-mini"
          @click="dialogTableVisible = false"
          >取 消</el-button
        >
        <el-button size="mini" type="primary-font-mini" @click="getCheckedNodes"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { qryFirstClassify } from "@/api/apply-shop-edit";
export default {
  data() {
    return {
      dialogTableVisible: false,
      value: [],
      options: [],
      props: {
        multiple: true,
        // props定义的值根据接口返回的数据定的
        label: "classifyName",
        value: "classifyCode",
        id: "classifyCode",
        children: "children",
        level: "cateryLevel"
      }
    };
  },
  props: ['shopManageClassifyCodeBos'],

  methods: {
    selectApi(e) {
      console.log(e, "eee");
    },
    handleItemChange(val, e) {
      console.log(val, "cascader");
      if (val.length == 1) this.openLast(val[0]);
    },
    open() {
      if (!this.options.length) {
        qryFirstClassify({}).then(res => {
          this.options = res.data.data;
          // this.value = ["01", "0101"];
          let list = []
          let a, b, c
          if (this.shopManageClassifyCodeBos) {
            this.shopManageClassifyCodeBos.forEach(i => {
              a = i.classifyCodes.split(',')
              b = a[3].split('\\')
              c = a.splice(0, 3)
              for (let i = 0; i < b.length; i++) {
                let combinedString = c.join(',') + ',' + b[i]
                list.push(combinedString)
              }
              this.value = list
              this.openLast(list[0].split(',')[0])
            })
          } else {
            this.openLast('01')
          }
        });
      }
      this.dialogTableVisible = true;
    },
    openLast(i, y1) {
      setTimeout(() => {
        let node = this.$refs.cascader.menus,
          caspanel = this.$refs.cascader;
        let userArr = node[0].filter(aa => aa.value == i);
        caspanel.handleExpand(userArr, true);
        caspanel.handleExpand(userArr[0], true);
        caspanel.handleExpand(userArr[0].children[0], true);
        caspanel.handleExpand(userArr[0].children[0].children[0], true);
      }, 60);
    },
    getCascaderObj(val, opt) {
      console.log(val, opt);
      return val.map(function(value, index, array) {
        for (var itm of opt) {
          if (itm.id == value) {
            opt = itm.children;
            return itm;
          }
        }
        return null;
      });
    },
    areArraysEqual(array1, array2) {
      if (array1.length !== array2.length) {
        return false;
      }

      for (let i = 0; i < array1.length; i++) {
        if (array1[i] !== array2[i]) {
          return false;
        }
      }

      return true;
    },
    getCheckedNodes() {
      let categoryData = [];
      // let objShowData = {};
      let nodesInfo = this.$refs["cascader"].getCheckedNodes();
      if (!nodesInfo.length){
        this.$emit("mergedStringArray", []);
        this.$emit("categoryCode", []);
        this.dialogTableVisible = false;
        return
      }else {
        nodesInfo.forEach(i => {
          if (i.pathLabels.length >= 4) {
            categoryData.push(i);
          }
        });
        //储存选中的名称
        const mergedArray = [];
        //储存选中的id
        const currentiDarray = [];
        for (let i = 0; i < categoryData.length; i++) {
          const currentSubarray = categoryData[i].pathLabels;

          currentiDarray.push({classifyCode:categoryData[i].path[3]});
          const lastMergedSubarray = mergedArray[mergedArray.length - 1];

          if (
            lastMergedSubarray &&
            this.areArraysEqual(
              currentSubarray.slice(0, 3),
              lastMergedSubarray.slice(0, 3)
            )
          ) {
            lastMergedSubarray.push(currentSubarray[3]);
          } else {
            mergedArray.push(currentSubarray);
          }
        }
        console.log(categoryData, "categoryData");
        console.log(currentiDarray, "currentiDarray");
        this.classifyBos=currentiDarray
        const mergedStringArray = mergedArray.map(subarray => {
          const firstThreeElements = subarray.slice(0, 3).join(">");
          const remainingElements = subarray.slice(3).join("/");
          return firstThreeElements + ">" + remainingElements;
        });
        const transformedArray = mergedStringArray.map(item => {
          return { categoryName: item };
        });
        // const mergedString = mergedStringArray.join(", ");

        this.$emit("mergedStringArray", transformedArray);
        this.$emit("categoryCode", currentiDarray);
        this.dialogTableVisible = false;
      }


    }
  },
  mounted() {}
};
</script>
<style scoped lang="scss">
/deep/.el-cascader-node.in-active-path,
/deep/.el-cascader-node.is-active,
/deep/.el-cascader-node.is-selectable.in-checked-path {
  color: #4a4a4a;
  font-weight: 500;
  background-color: #ffefd5;
}
/deep/.el-cascader-node:not(.is-disabled):focus,
/deep/.el-cascader-node:not(.is-disabled):hover {
  background: #ffefd5;
}
</style>
